document.addEventListener('DOMContentLoaded', function() {
  // search desktop
  const dskSearch = document.querySelector('.large-desktop-search');
  const srcIcon = document.querySelector('.header-search-icon');
  srcIcon.addEventListener('click', e => {
    const target = e.currentTarget;
    const isOpen = target.getAttribute('open') ? true : false;
    const iconSrc = target.querySelector('.icon-search');
    const iconClose = target.querySelector('.icon-close');
    e.preventDefault();
    if (isOpen) {
      target.removeAttribute('open');
      dskSearch.style.display = 'none';
      iconSrc.style.display = 'block';
      iconClose.style.display = 'none';
    } else {
      target.setAttribute('open', true);
      dskSearch.style.display = 'block';  
      iconSrc.style.display = 'none';
      iconClose.style.display = 'block';
    }
  });
  
  // select variant
  const quickAddVariant = document.querySelectorAll('.quick-add-variant');
  if (quickAddVariant) {
    quickAddVariant.forEach(el => {
      el.addEventListener('change', e => {
        const target = e.currentTarget;
        const parent = target.closest('.card__content');
        // change variant id
        const prodIdEl = parent.querySelector('input[name="id"]');
        prodIdEl.value = target.value;
        // change price
        const selectedIndex = target.selectedIndex;
        const priceHTML = target.options[selectedIndex].dataset.priceHtml;
        const prodPriceEl = parent.querySelector('.price-item--regular');
        prodPriceEl.innerHTML = priceHTML;
      });
    });
  }

  // add subtitle to product reviews
  const stampedReviews = document.getElementById('stamped-reviews-widget');
  const isIndex = document.querySelector('.template-index');
  if (stampedReviews && isIndex) {
    stampedReviews.prepend('<div class="stamped-carousel-subtitle">PRODUCT REVIEWS</div>')
  }

  // show filter 
  const collectionGrid = document.querySelector('.template-collection .product-grid');
  if (collectionGrid) {
    collectionGrid.classList.remove('grid--3-col-desktop');
    collectionGrid.classList.add('grid--4-col-desktop');
    const showFilters = document.querySelector('.show-filters');
    if (showFilters) {
      showFilters.addEventListener('click', e => {
        const target = e.currentTarget;
        const parent = target.closest('.product-showcase');
        const aside = parent.querySelector('.facets-wrapper');
        const span = target.querySelector('span');
        const text = span.textContent;
        const grid = parent.querySelector('.product-grid');
        if (text == 'SHOW FILTERS') {
          span.textContent = 'HIDE FILTERS';
          parent.classList.add('show-filter');
          aside.style.display = 'block';
          grid.classList.remove('grid--4-col-desktop');
          grid.classList.add('grid--3-col-desktop');
        } else {
          span.textContent = 'SHOW FILTERS';
          parent.classList.remove('show-filter');
          aside.style.display = 'none';
          grid.classList.remove('grid--3-col-desktop');
          grid.classList.add('grid--4-col-desktop');
        }
      });
    }
  }

  // Product sliders
  // const sliders = document.querySelectorAll('.product-slider');
  // if (sliders) {
  //   sliders.forEach(slider => new ProductSlider(slider));
  // }

  // product grid image links
  const gridImg = document.querySelectorAll('.product-card-wrapper .card__media');
  if (gridImg) {
    gridImg.forEach(img => {
      img.addEventListener('click', e => {
        const target = e.currentTarget;
        const url = target.dataset.prodUrl;
        window.location.href = url;
      });
    });
  }
  
});
// product slider class - added to global.js
// class ProductSlider {
//   constructor(container) {
//     this.container = container;
//     this.slider = container.querySelector('.product-slider__wrapper');
//     this.slides = container.querySelectorAll('.product-slider__slide');
//     this.prevButton = container.querySelector('.slider-button--prev');
//     this.nextButton = container.querySelector('.slider-button--next');
//     this.progressBar = container.querySelector('.slider-line__progress');
//     this.slidesPerView = this.slidesView(window.innerWidth);

//     // Initialize Flickity
//     this.flkty = new Flickity(this.slider, {
//       cellAlign: 'left',
//       contain: true,
//       pageDots: false,
//       prevNextButtons: false,
//       wrapAround: true,
//       groupCells: this.slidesPerView,
//       draggable: true,
//     });

//     // Button click listeners
//     this.prevButton.addEventListener('click', () => this.flkty.previous());
//     this.nextButton.addEventListener('click', () => this.flkty.next());

//     // Window resize event listener
//     window.addEventListener('resize', () => {
//       this.slidesPerView = this.slidesView(window.innerWidth);
//       this.flkty.options.groupCells = this.slidesPerView; // Update the grouping on resize
//       this.flkty.resize(); // Trigger Flickity to recalculate
//     });

//     this.updateProgressBar();
//     this.updateButtonStates();

//     // Flickity events
//     this.flkty.on('scroll', () => this.updateProgressBar());
//     this.flkty.on('change', () => this.updateButtonStates());
//   }

//   slidesView(width) {
//     if (width < 768) {
//       return 1;
//     } else if (width >= 768 && width <= 991) {
//       return 2;
//     } else {
//       return 4;
//     }
//   }

//   updateProgressBar() {
//     const totalSlides = this.flkty.slides.length;
//     const progress = ((this.flkty.selectedIndex + 1) / totalSlides) * 100;
//     this.progressBar.style.width = `${progress}%`;
//   }

//   updateButtonStates() {
//     const totalSlides = this.flkty.slides.length;

//     // Update previous button state
//     if (this.flkty.selectedIndex === 0) {
//       this.prevButton.classList.add('inactive');
//     } else {
//       this.prevButton.classList.remove('inactive');
//     }

//     // Update next button state
//     if (this.flkty.selectedIndex === totalSlides - this.slidesPerView) {
//       this.nextButton.classList.add('inactive');
//     } else {
//       this.nextButton.classList.remove('inactive');
//     }
//   }
// }


// document.addEventListener('DOMContentLoaded', () => {
//   const sliders = document.querySelectorAll('.product-slider');
//   sliders.forEach(slider => new ProductSlider(slider));
// });